import { IClient } from '@/interfaces/clients';

export const getClients = async () => {
  const response = await fetch(`${import.meta.env.VITE_API_URL}/clients`);
  const responseData = await response.json();

  return responseData as Array<IClient>;
};
